import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function Client(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        d="M12 12c3.315 0 6-2.685 6-6s-2.685-6-6-6-6 2.685-6 6 2.685 6 6 6Zm0 3c-4.005 0-12 2.01-12 6v3h24v-3c0-3.99-7.995-6-12-6Z"
        fill="currentColor"
      />
    </IconWrapper>
  );
}
